const ROOT = (process.env.REACT_APP_BACKEND_URL ?? '') + '/api/exports-fiscaux';
export async function fiscal(path, { method = 'GET', body, signal } = {}) {
  // Le transport global lib/http fournit le CSRF et la session ; aucun rôle client.
  const r = await fetch(ROOT + path, {
    method, credentials: 'include', cache: 'no-store', signal,
    headers: { 'Content-Type': 'application/json' },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await r.json().catch(() => null);
  if (!r.ok || !data) {
    const detail = data?.detail;
    throw new Error(typeof detail === 'string' ? detail : `Export impossible (${r.status}) : ${JSON.stringify(detail || 'réponse invalide')}`);
  }
  return data;
}
export function moisCourantTunis() {
  const parts = new Intl.DateTimeFormat('en', { timeZone: 'Africa/Tunis', year: 'numeric', month: '2-digit' }).formatToParts(new Date());
  return `${parts.find(p => p.type === 'year').value}-${parts.find(p => p.type === 'month').value}`;
}
export function requeteExport(type, mois) {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(mois)) throw new Error('Choisissez un mois valide.');
  if (type === 'cnss') return `/etat-cnss?mois=${mois}&format=json`;
  const [an, m] = mois.split('-').map(Number);
  const jours = new Date(Date.UTC(an, m, 0)).getUTCDate();
  return `/${type === 'ventes' ? 'journal-ventes' : 'etat-rs'}?du=${mois}-01&au=${mois}-${jours}&format=json`;
}
export function telechargerFiscal(data) {
  if (typeof data.csv !== 'string' || !data.nom?.endsWith('.csv')) throw new Error('Réponse export invalide : aucun fichier téléchargé.');
  const url = URL.createObjectURL(new Blob([data.csv], { type: 'text/csv;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url; a.download = data.nom; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
